import { combineReducers } from "redux";
import { Modals } from "./Modals";
import Settings from "./Settings";

const rootReducer = combineReducers({
  Settings: Settings,
  modals: Modals
});
export default rootReducer;
